<div class="map-route-container bg-gray-400">
  <div class="user-container bg-white p-6 flex flex-between cursor-pointer" (click)="openDrawer=true">
    <img src="{{currentLocation?.user?.profile_picture}}" class="w-14 h-14 rounded-full" alt="">
    <div class="ml-3">
      <p class="text-lg font-semibold text-gray-700">{{currentLocation?.user?.first_name}} {{currentLocation?.user?.last_name}}</p>
      <p class="text-base">{{currentLocation?.user?.designation}}</p>
    </div>
  </div>
  <div class="sidebar-container bg-white overflow-auto p-4 cursor-default zuper-scrollbar">
    <p class="font-semibold text-xl">{{'location.history.jobs_for' | translate}} 
      <input 
            readonly="true"
            [matDatepicker]="routeDatePicker"
            type="text" 
            name="currentDate"
            id="currentDate"  
            [(ngModel)]="currentDate"
            class="border-b border-gray-700 border-dotted cursor-pointer w-28 font-semibold"
            [placeholder]="utilityService.getLocaleValue('input.placeholder.pick_date')"
            (click)="routeDatePicker.open()"
            value=""
            [datePickerFormat]="dateFormat"
            (dateChange)="historyDateChange($event)"
            [max]="today"
    >
      <mat-datepicker [dateClass]="dateClass"  #routeDatePicker></mat-datepicker>
    </p>
    <ng-container *ngIf="allJobs?.length === 0">
      <img src="../../../../assets/images/svgs/job_placeholder.svg" alt="" class="w-40 h-40 mx-auto mt-2">
      <p class="text-lg font-semibold text-center">{{'location.no_jobs_assigned' | translate}} {{currentLocation?.user?.first_name}} {{currentLocation?.user?.last_name}} {{'on.label' | translate}} {{currentDate | dateformat}}</p>
    </ng-container>
    <ng-container *ngFor="let j of allJobs">
      <mat-expansion-panel class="rounded-lg border mt-2">
        <mat-expansion-panel-header class="w-full px-2">
          <mat-panel-title class="w-full">
            <h3 class="mb-3 text-lg font-semibold my-3 truncate w-full">#{{j?.prefix}}{{j?.work_order_number}} - {{j?.job_title}}</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="cursor-pointer" (click)="setJobView(j?.customer_address)">
          <div class="flex justify-between mb-3 h-5 p-3">
            <h5 class="text-base font-bold tracking-tight text-gray-900 h-6 truncate w-full">{{j?.prefix}} {{j?.work_order_number}} {{j.job_title}}</h5>
            
          </div>
            <div class="flex my-1 px-3" *ngIf="j?.scheduled_start_time && j?.scheduled_end_time">
              <i class="ti ti-calendar-minus"></i>
              <span class="text-base ml-1">{{j?.scheduled_start_time | datetime}} - {{j?.scheduled_end_time | datetime}}</span>
            </div>
            <div class="flex my-1 px-3" *ngIf="!(j?.scheduled_start_time && j?.scheduled_end_time) && j?.due_date">
              <i class="ti ti-calendar-minus"></i>
              <span class="text-base ml-1">{{'text.due_by' | translate}} {{j?.due_date | datetime}}</span>
            </div>
            <div class="flex my-1 px-3" *ngIf="j?.customer?.customer_first_name && j?.customer?.customer_last_name">
              <i class="ti ti-user"></i>
              <span class="text-base ml-1">{{j?.customer?.customer_first_name}} {{j?.customer?.customer_last_name}}</span>
            </div>
            <div class="flex my-1 px-3" *ngIf="j?.customer_address">
              <i class="ti ti-map-pin"></i>
              <span class="text-base ml-1">{{j?.customer_address?.street}}{{(j?.customer_address?.city) ? ", "+j.customer_address.city : ''}}{{(j?.customer_address?.state) ? ", "+j.customer_address.state : ''}}{{(j?.customer_address?.country) ? ", "+j.customer_address.country : ''}}</span>
            </div>
            <div class="w-full border-t my-2 mt-3"></div>
            <h5 class="text-base font-semibold tracking-tight text-gray-900 h-5 truncate w-full px-3">{{'users.assigned.text' | translate}}</h5>
            <div class="flex mt-1 px-3" *ngIf="j?.assigned_to?.length > 0">
              <span class="text-base">{{j?.assigned_to[0]?.user?.first_name}} {{j?.assigned_to[0]?.user?.last_name}} <a class="ml-1 text-indigo-500" *ngIf="j?.assigned_to?.length > 1">+{{j?.assigned_to?.length - 1}} {{'text.more'| translate | lowercase}}</a> </span>
            </div>
            <div class="w-full border-t my-2 mt-3"></div>
            <div class="flex px-3 pb-3" [ngClass]="{'justify-between':j?.current_job_status,'justify-end':!j?.current_job_status}">
                <div *ngIf="j?.current_job_status">
                    <badge
                    [options]="getJobStatusOptions(j?.current_job_status)"></badge>
                </div>
                <badge class="text-base leading-none" *ngIf="j?.job_priority" [options]="getJobPriorityBadgeOptions(j)"></badge>
            </div>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </div>
    <div id="map">
      <div class="ml-2 absolute bottom-2 tile-layer-parent" >
        <span class="w-12 h-12 tile-layer-satellite cursor-pointer border-2 border-gray-500 shadow-md rounded-md" *ngIf="currentTitleType === 'DEFAULT'" title="{{'satellite.view' | translate}}" (click)="setTileLayer('SATELLITE', $event)"></span>
        <span class="w-12 h-12 tile-layer-default cursor-pointer border-2 border-gray-500 shadow-md rounded-md"  *ngIf="currentTitleType === 'SATELLITE'"  title="{{'map.view' | translate}}"  (click)="setTileLayer('DEFAULT', $event)"></span>
      </div>
    </div>
    <preview-data [drawerOpen]="openDrawer" [module]="'USER'" class="map-preview-data"
            [moduleUID]="userUid" [options]="previewOptions" (eventEmitter)="previewDataEventHandler($event)">
    </preview-data>
</div>